import { useQuery } from "react-query";
import AxiosT from "../../setup/setup-axios-bearer";

async function fetchGetBarcodeList(id, pd_id) {
  const res = await AxiosT.get(`/barcode-list?id=${id}&pd_id=${pd_id}`);
  return res.data;
}

export function useGetBarcodeList(id, pd_id) {
  return useQuery(["getBarcodeList", id, pd_id], () =>
    fetchGetBarcodeList(id, pd_id)
  );
}
